var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dropdown", {
    attrs: {
      value: _vm.sort,
      label: _vm.$t("wizard.sort"),
      options: _vm.sortOptions,
    },
    on: { select: _vm.onSortSelect },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }